export const c_tabs_m_box__item_action_c_button_disabled_BackgroundColor = {
  "name": "--pf-c-tabs--m-box__item-action--c-button--disabled--BackgroundColor",
  "value": "#b8bbbe",
  "var": "var(--pf-c-tabs--m-box__item-action--c-button--disabled--BackgroundColor)"
};
export default c_tabs_m_box__item_action_c_button_disabled_BackgroundColor;